const NotImageIcon = () => (
  <svg width="50" height="47" viewBox="0 0 50 47" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.5 6C5.5 2.69063 7.98509 0 11.0417 0H44.2917C47.3482 0 49.8333 2.69063 49.8333 6V36C49.8333 39.3094 47.3482 42 44.2917 42H11.0417C7.98509 42 5.5 39.3094 5.5 36V6ZM33.5374 15.9844C33.1477 15.3656 32.507 15 31.8229 15C31.1389 15 30.4895 15.3656 30.1085 15.9844L22.5753 27.9469L20.2807 24.8438C19.8824 24.3094 19.2849 24 18.6615 24C18.038 24 17.4319 24.3094 17.0423 24.8438L11.5006 32.3438C10.9984 33.0188 10.9031 33.9469 11.2495 34.725C11.5958 35.5031 12.3232 36 13.1198 36H21.4323H24.2031H42.2135C42.9842 36 43.6942 35.5406 44.0492 34.8C44.4042 34.0594 44.3609 33.1688 43.928 32.4844L33.5374 15.9844ZM15.1979 15C16.3002 15 17.3574 14.5259 18.1368 13.682C18.9163 12.8381 19.3542 11.6935 19.3542 10.5C19.3542 9.30653 18.9163 8.16193 18.1368 7.31802C17.3574 6.47411 16.3002 6 15.1979 6C14.0956 6 13.0385 6.47411 12.259 7.31802C11.4796 8.16193 11.0417 9.30653 11.0417 10.5C11.0417 11.6935 11.4796 12.8381 12.259 13.682C13.0385 14.5259 14.0956 15 15.1979 15Z"
      fill="#D3D3D3"
    />
    <path
      d="M3.16699 2.33301L47.5003 44.333"
      stroke="white"
      strokeWidth="4.66667"
      strokeLinecap="round"
    />
    <path
      d="M7.83301 2.33301L47.4997 39.6663"
      stroke="#D3D3D3"
      strokeWidth="4.66667"
      strokeLinecap="round"
    />
  </svg>
);

export default NotImageIcon;
